import React, { createContext, useContext } from 'react'

import useFilters from '@components/Filter/useFilters'

const FiltersContext = createContext()

export const FiltersProvider = ({ children }) => {
  const { state, dispatch } = useFilters()

  const callbacks = {
    resetFilters: () => dispatch({ type: 'RESET_FILTERS' }),
    setFilter: filter => dispatch({ type: 'SET_FILTER', filter }),
    setSortBy: sortBy => dispatch({ type: 'SET_SORTBY', sortBy }),
    toggleShowFilters: () => dispatch({ type: 'SET_SHOW_FILTERS' })
  }

  return <FiltersContext.Provider value={{ ...callbacks, ...state }}>{children}</FiltersContext.Provider>
}

export const useFiltersContext = () => {
  return useContext(FiltersContext)
}
